import { Button } from "@mui/material";
import React, { Fragment } from "react";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PaymentForm from "./PaymentForm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PaymentStatusEnum = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  NOTPAID: "notpaid",
};

export const PaymentAction = (props) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const paymentStatus = props.paymentStatus;
  const color =
    paymentStatus === PaymentStatusEnum.APPROVED
      ? "#94FF51"
      : paymentStatus === PaymentStatusEnum.REJECTED
      ? "#FF5151"
      : paymentStatus === PaymentStatusEnum.PENDING
      ? "#FFF58C"
      : "grey";

  const paymentObj=props.paymentObj

  return (
    <Fragment>
      <Button
        onClick={handleOpen}
        variant="contained"
        sx={{
          backgroundColor:
           color,
          "&.Mui-disabled": {
            background: color,
         
          },
          '&:hover': {
            backgroundColor: "grey",
          },
          width: "100px",
        }}
        disabled={paymentStatus !== PaymentStatusEnum.NOTPAID}
      >
        {paymentStatus}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PaymentForm paymentObj={paymentObj} handleClose={handleClose}/>
        </Box>
      </Modal>
    </Fragment>
  );
};
